import { render, staticRenderFns } from "./Payment-barcode.vue?vue&type=template&id=4a7ec797&"
import script from "./Payment-barcode.vue?vue&type=script&lang=js&"
export * from "./Payment-barcode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports